module.exports = __webpack_public_path__ + "static/media/reportedCampaignsActive.f755d1a3.png";